// Custom global error boundary. The built-in one tries to prerender inside the
// app's client Providers (next-auth / zustand), which crashes during `next build`
// (Cannot read properties of null reading 'useContext'). This minimal version
// has no context dependency and opts out of static rendering.
"use client";

export const runtime = "nodejs";
export const dynamic = "force-dynamic";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <html lang="fa" dir="rtl">
      <body className="min-h-screen flex items-center justify-center bg-background">
        <div className="max-w-md space-y-4 p-6 text-center">
          <h1 className="text-xl font-bold">خطایی رخ داده است</h1>
          <p className="text-sm text-muted-foreground">{error.message}</p>
          <button
            type="button"
            onClick={reset}
            className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
          >
            دوباره امتحان کنید
          </button>
        </div>
      </body>
    </html>
  );
}
